import { render } from "./ListePermission.vue?vue&type=template&id=e032a5de&ts=true"
import script from "./ListePermission.vue?vue&type=script&lang=ts"
export * from "./ListePermission.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__